// extracted by mini-css-extract-plugin
export default {"category-card":"Categories_category-card__q1cNX","category-img":"Categories_category-img__M6w1t"};